export default __webpack_public_path__ + "static/media/Version (5) - Deathly Hallows - Thumbnail.f3f72001.png";